import { AppShell, useMantineColorScheme } from '@mantine/core';

import { Outlet } from 'react-router-dom';
import useSidebarStore from '../store/sidebar/sidebar.store';
import { DefaultHeader } from './DefaultHeader';
import { DefaultSidebar } from './DefaultSidebar/DefaultSidebar';
import useAuthStore from '@/store/auth/auth.store';
import { useTranslations } from '@/lib/i18n';
import LoadingBox from '@/components/loading-box';

const Layout = () => {
  const { colorScheme } = useMantineColorScheme();
  const { collapsed } = useSidebarStore();
  const { retrying } = useAuthStore();
  const t = useTranslations();

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{ width: 200, breakpoint: 'sm', collapsed: { mobile: collapsed, desktop: collapsed } }}
      padding={0}
      style={(theme) => ({
        main: {
          backgroundColor: colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
          maxWidth: '100%'
        }
      })}>
      <AppShell.Header>
        <DefaultHeader />
      </AppShell.Header>
      <AppShell.Navbar>
        <DefaultSidebar />
      </AppShell.Navbar>

      <AppShell.Main>
        {retrying && <LoadingBox>{t('common.loading')}</LoadingBox>}
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};

export default Layout;
